export default __webpack_public_path__ + "static/media/wordGame.9689cea9.gif";